import { IconButton } from '@mui/material';
import { ChevronLeftIcon } from '@/src/components/icon/stroke/ChevronLeftIcon';
import { ChevronRightIcon } from '@/src/components/icon/stroke/ChevronRightIcon';

/**
 * This component renders a scroll button that changes based on the scroll direction
 */
export const TabsScrollButton = ({ direction, slots, slotProps, ownerState, ...rest }) => {
  return (
    <IconButton
      aria-label={direction === 'left' ? 'Scroll left' : 'Scroll right'}
      data-testid={`TabsScrollButton-${direction}`}
      size="small"
      sx={{ m: '4px' }}
      {...rest}
    >
      {direction === 'left' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
    </IconButton>
  );
};
